import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import React, { FC } from 'react';
import { TranslatedString, Text, cognate } from '../blocks';
import { PopoverCell } from '../constructed';

export interface TruncatedTextProps {
    text: TranslatedString;
    maxWidth?: number;
    dataTestId?: string;
    noWrap?: boolean;
}

const TruncatedText: FC<TruncatedTextProps> = ({ text, maxWidth, dataTestId, noWrap }: TruncatedTextProps) => {
    if (maxWidth && text.length > maxWidth) {
        const truncatedString = text.substr(0, maxWidth);
        const truncatedContent = (
            <>
                <Text tag={noWrap ? 'span' : undefined} data-testid={`${dataTestId}-Text`}>
                    {cognate(truncatedString)}
                </Text>
                <PopoverCell buttonLable={'…'} data-testid={`${dataTestId}-PopoverCell`}>
                    <Column alignmentHorizontal={'left'} alignmentVertical={'top'} spacing={'xxsmall'}>
                        <Text type={'b200'} data-testid={`${dataTestId}-Full Text`}>
                            {text}
                        </Text>
                    </Column>
                </PopoverCell>
            </>
        );

        return noWrap ? (
            <span style={{ whiteSpace: 'nowrap' }} data-testid={dataTestId}>
                {truncatedContent}
            </span>
        ) : (
            <Row spacing={'none'} data-testid={dataTestId}>
                {truncatedContent}
            </Row>
        );
    } else {
        return <Text data-testid={dataTestId}>{text}</Text>;
    }
};

export { TruncatedText };
